module.exports = __webpack_public_path__ + "assets/amazon-ses.1a1c974b.svg";